module.exports = __webpack_public_path__ + "static/media/sound.99013af.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sound.mp3
// module id = kggY
// module chunks = 1